@let notificationItem = notification();

<flx-notification-content
  [notification]="notificationItem"
  (actionClicked)="actionClicked.emit()"
>
  <div
    class="flex items-center gap-2"
    notificationTitle
  >
    <div
      [pTooltip]="notificationItem.title"
      [showDelay]="TOOLTIP_DEFAULT_DELAY"
      [showOnEllipsis]="true"
      [class.font-semibold]="!notificationItem.markedRead"
      class="flex-1 truncate text-sm/6 text-neutral-900"
      data-testid="notification-title"
      tooltipPosition="top"
      tooltipStyleClass="flx-prime-tooltip"
      tooltipZIndex="{{ TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX }}"
    >
      {{ notificationItem.title }}
    </div>

    <div class="relative flex shrink-0 items-center">
      <button
        [pTooltip]="readToggleLabel()"
        [showDelay]="TOOLTIP_DEFAULT_DELAY"
        [attr.aria-label]="readToggleLabel()"
        (click)="toggleRead()"
        class="flx-ds small neutral peer absolute -right-1.5 opacity-0 focus-visible:opacity-100 group-hover:opacity-100"
        clickStopPropagation
        flxButton
        icon="center"
        variant="text"
        type="button"
        data-testid="notification-read-toggle"
        tooltipPosition="top"
        tooltipStyleClass="flx-prime-tooltip"
        tooltipZIndex="{{ TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX }}"
      >
        <i
          [class]="notificationItem.markedRead ? 'ph-envelope-simple-open' : 'ph-envelope-simple'"
          class="ph"
          flxIcon
        ></i>
      </button>

      <!-- Fixed width so the read toggle, which takes the time's place on hover or keyboard focus,
      fits however short the time is: `age()` runs from `1h` to `28 mins`. -->
      <span
        class="w-14 text-right text-xs/4 text-neutral-300 group-hover:invisible peer-focus-visible:invisible"
        data-testid="notification-age"
      >
        {{ age() }}
      </span>
    </div>
  </div>
</flx-notification-content>
